export default "/images/6b00839b98a1f2900135f7f781da21bc.avif";